<template>
  <div>
    <!-- Object.keys(tgoUserInfo).length > 1，这里判断大于 1，是因为默认会有 is_redect 字段 -->
    <div
      v-if="
        Object.keys(tgoUserInfo).length > 1 &&
        !isAdmin &&
        !isOnlyApplyMember
      "
    >
      <base-info v-if="!isEditing" @setState="setState" @notifyInfos="getInfos" :tgoUserInfo="tgoUserInfo" :statusInfo="statusInfo"></base-info>
      <base-modify v-else @setState="setState" @submit="submitInfo" :info="initData" :tgoUserInfo="tgoUserInfo"></base-modify>
    </div>
    <div class="warnTip" v-else>
      <div class="warnTip-center">
        <img class="warnTip-center-img" src="../../assets/img/sad.png" />
        <div class="warnTip-center-word">暂无信息</div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import { getBranchAll } from '@/util/methods.js'
import baseInfo from './info'
import baseModify from './modify'
import lodash from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isEditing: false,
      initData: '', // 克隆info
      statusInfo: {
        status: '',
        explanation: '',
        avatar: '',
        half_length_portrait: ''
      },
      tgoUserInfo: {}
    }
  },

  created () {
    // this.tgoUserInfo = { name: '王猛' }
    service.getUserInfo().then(res => {
      this.tgoUserInfo = res
      // get 分会数据
      getBranchAll().then(data => { this.tgoUserInfo.branch = data.filter(item => item.id === Number(this.tgoUserInfo.expect_to_join))[0] })
        .catch(err => { console.log(err) })
    }).catch(err => { console.log(err) })
    // 状态信息的接口
    service.getUserStatus().then(_ => { this.statusInfo = _ })
      .catch(err => console.log(err))
  },

  components: {
    baseInfo,
    baseModify
  },

  computed: {
    ...mapGetters([
      'isAdmin',
      'isOnlyApplyMember'
    ])
  },

  methods: {
    setState () {
      this.isEditing = !this.isEditing
    },
    submitInfo (info) {
      let infoClone = lodash.cloneDeep(info)
      if (infoClone['focus_areas_tags']) {
        infoClone['focus_areas_tags']['1'] = infoClone['focus_areas_tags']['1'].map(t => Number(t.id))
      }
      // 更新数据
      service.updateInfo(infoClone).then(() => {
        this.setState()
        this.tgoUserInfo = info
      })
        .catch(err => console.log(err))
    },
    getInfos () {
      this.initData = lodash.cloneDeep(this.tgoUserInfo)
    }
  }
}
</script>
<style scoped lang='sass'>

.warnTip
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  padding: 100px 0
  .warnTip-center
    .warnTip-center-img
      width: 100px
    .warnTip-center-word
      margin: 0 auto
      margin-top: 10px
      text-align: center
</style>
